import { makeAutoObservable, runInAction } from 'mobx'
import { string } from 'yup'
import InputStore from '../../stores/InputStore'
import CasesService from '../../services/CasesService'
import constants from '../../util/constants'
import { MAINTENANCE_MODE } from '../../routing/paths'



class ManualSearchStore {
  constructor () {
    this.areas = []
    this.area = ''
    this.caseNumber = new InputStore(string())
    this.licensePlateNumber = new InputStore(string().matches(/^[A-Za-z0-9]*$/,'License can only contain numbers and letters'))
    this.licensePlateState = new InputStore(string())
    this.isLoading = false
    this.serverError = ''
    makeAutoObservable(this)

    this.casesService = new CasesService()
  }

  changeArea (value) {
    runInAction(() => {
      this.area = {
        id: value.id, 
        name: value.name, 
        imageUrl: value.image_url,
        operations: value.operations.map((operation) => { return operation.id })
      }
    })
  }

  async loadAreas () {
    const auxAxios = axios.create()
    return auxAxios
      .get(`/driver-api/areas`)
      .then(({ data }) => 
      {
        runInAction(() => {
          this.areas = data.data
        })
      })
  }

  changeCaseNumber (value) {
    this.caseNumber.setValue(value)
  }

  changeLicensePlateNumber (value) {
    this.licensePlateNumber.setValue(value)
  }

  changeLicensePlateState (value) {
    this.licensePlateState.setValue(value)
  }

  clearErrors () {
    this.serverError = ''
    this.caseNumber.clearError()
    this.licensePlateNumber.clearError()
    this.licensePlateState.clearError()
  }

  async validate () {
    this.clearErrors()
    let isValid = true

    if (!(await this.caseNumber.validate())) {
      isValid = false
    }

    if (!(await this.licensePlateNumber.validate())) {
      isValid = false
    }

    if (!(await this.licensePlateState.validate())) {
      isValid = false
    }

    return isValid
  }

  async search (token) {
    if (this.isLoading) {
      return false
    }
    this.isLoading = true
    if (await this.validate()) {
      runInAction(() => {
        this.isLoading = true
      })

      try {
        const immobilizationCase = await this.casesService.searchCase(
          this.caseNumber.value,
          this.licensePlateNumber.value,
          this.licensePlateState.value,
          constants.releaseMethodCodes.Manual,
          this.area?.operations,
          token
        )

        runInAction(() => {
          this.isLoading = false
        })

        return immobilizationCase
      } catch (e) {
        runInAction(() => {
          if (e?.response?.status === 404) {
            this.serverError = "Sorry, we couldn't find a case for the provided data."
          } else if (e?.response?.status === 503) {
            window.location.href = `${MAINTENANCE_MODE}?phone=${e?.response?.data.phone}`
          } else {
            const displayedError = this.parseRequestErrors(e.response?.data?.errors || {})

            if (!displayedError) {
              this.serverError =
                'Something went wrong, please check the provided data and try again.'
            }
          }

          this.isLoading = false
        })
      }
    }

    runInAction(() => {
      this.isLoading = false
    })

    return false
  }

  parseRequestErrors (messages) {
    const keys = Object.keys(messages)
    let displayedError = false

    keys.forEach((key) => {
      const [error] = messages[key]

      switch (key) {
        case 'id':
          this.caseNumber.setError(true, error)
          displayedError = true
          break

        case 'license':
          this.licensePlateNumber.setError(true, error)
          displayedError = true
          break

        case 'state':
          this.licensePlateState.setError(true, error)
          displayedError = true
          break

        default:
          break
      }
    })

    return displayedError
  }
}

export default ManualSearchStore
